import MainPressureVessel from "../PressureVessel";
import DataTabs from "../PressureVessel/PressureVesselData";
import AssetManagementTab from "./AssetManagementTab";
// import DCS from "./DCS";
import DCSTab from "./DCSTab";
// import DownloadPage from "./DownloadPage";
import EstimationTab from "./EstimationTab";
import MCS3 from "./MCS3";
// import MCSPage from "./MCSTab";
import PCS from "./PCSTab";
// import PMSTabs from "./PMSTab";
import PMSTab2 from "./PMSTab2";
import PVModeling from "./PV3";

export const equipMainTabs = [
  // "File",
  // "Data",
  // "Calc.",
  "Est.",
  "DCS",
  "MCS",
  "PCS",
  // "AMS",
  "PMS",
  // "PV Modeling",
  "PV",
  // "Software",
];

export const CommonTabs = (reRender, project) => [
  {
    id: "Est.",
    title: "EstimationTab",
    panel: <EstimationTab reRender={reRender} />,
    // panelProps: { backgroundColor: "transparent", padding: 3 },
  },
  {
    id: "DCS",
    title: "DCSPage",
    panel: <DCSTab reRender={reRender} />,
  },
  {
    id: "MCS",
    title: "MCSPage",
    // panel: <MCSPage />
    panel: <MCS3 project={project} />,
  },
  {
    id: "PCS",
    title: "PCS",
    panel: <PCS />,
  },
  // {
  //id:"",//
  //  title: "AssetManagementTab",
  //     panel: <AssetManagementTab />
  // },
  {
    id: "PMS",
    title: "PMSTab",
    panel: <PMSTab2 />,
  },

  {
    id: "",
    title: "PV Modeling",
    panel: <PVModeling />,
  },

  //old
  // {
  // id:"",//
  //title: "PV",
  //   panel: <DataTabs />,
  // },

  // {
  //  id:"",//
  //title: "DownloadPage",
  //     panel: <DownloadPage /> MainPressureVessel
  // },
];
